Pegasus.TextFieldWithLimit = Ember.View.extend({
  classNames: ['text-field-with-limit'],
  classNameBindings: ['hasErrors:error', 'isFocused:focused'],
  templateName: 'controls/text_field_with_limit',
  charactersRemaining: null,
  value: '',

  valueDidChange: function(){
    if ( !this.$() ) { return; }

    if ( this.get('maxLength') ) {
      this.set('charactersRemaining', (this.get('maxLength') - (this.get('value.length') || 0)) + '/' + this.get('maxLength') );

      if ( this.get('value.length') > this.get('maxLength') ) {
        this.set('value', this.get('value').slice(0, this.get('maxLength') ) );
      }
    }
  }.observes('value.length'),

  hasErrors: Ember.computed.gt( 'errors.length', 0 ),

  focusIn: function(){
    this.set('errors', []);
    this.valueDidChange();
    this.set('isFocused', true);
  },

  focusOut: function(){
    this.set('isFocused', false);
    this.set('charactersRemaining', null);
  },

  suppressErrors: false,

  input: Ember.TextField.extend({
    id: function(){
      return Ember.generateGuid();
    }.property(),
    valueBinding: 'parentView.value',
    placeholderBinding: 'parentView.placeholder',
    nameBinding: 'parentView.fieldName',
    disabledBinding: 'parentView.disabled',
    spellcheckBinding: 'parentView.spellcheck'
  })
});

Pegasus.LinkTextField = Pegasus.TextFieldWithLimit.extend({
  maxLength: 300,
  linkType: Em.required(),

  linkTypes: {
    Website: Em.Object.create({
      loadTester: function(view){
        import( 'valid-url' ).then(function(lib){
          this.set('lib', lib);
          Em.run.scheduleOnce('afterRender', view, 'testLink', this);
        }.bind(this));
      },
      test: function(value){
        return this.get('lib').isUri( value );
      },
      error: Em.I18n.t('g.invalid_url')
    }),
    Email: Em.Object.create({
      loadTester: function(view){
        import( 'email-validator' ).then(function(lib){
          this.set('lib', lib);
          Em.run.scheduleOnce('afterRender', view, 'testLink', this);
        }.bind(this));
      },
      test: function(value){
        return this.get('lib').validate(value);
      },
      error: Em.I18n.t('g.invalid_email')
    })
  },

  valueDidChange: function(){
    if ( !this.$() ) { return; }

    var value = this.get('value');
    if ( value !== value.trim() ) {
      this.set('value', value.trim());
      return;
    }

    this._super();
    if(this.get('linkTypes')[this.get('linkType')]) {
      this.get('linkTypes')[this.get('linkType')].loadTester(this);
    }
  }.observes('value.length'),

  testLink: function(link){
    var value = this.get('value');
    this.set('errors', []);
    if ( !link.test(value) ) {
      this.set('errors', [ link.error ]);
    }
  }
});

Pegasus.LinkTextFieldAllowEmpty = Pegasus.LinkTextField.extend({
  didInsertElement: function() {
    this._super();

    if(this.get('value') === '') {
      this.set('errors', []);
    } else {
      if(this.get('linkTypes')[this.get('linkType')]) {
        this.get('linkTypes')[this.get('linkType')].loadTester(this);
      }
    }
  },

  testLink: function(link){
    var value = this.get('value');
    this.set('errors', []);
    if ( value && !link.test(value) ) {
      this.set('errors', [ link.error ]);
    }
  }
});
